import * as SUBMITTED_WARRANTY_ACTION_TYPE from "./actionTypes";

export const initialState = {
    submittedList: [],
    stateOrProvinceList: {
        "": [{ label: "Select State", value: "" }],
        USA: [{ label: "Select State", value: "" }],
        CAN: [{ label: "Select Province", value: "" }],
    },
    isLoading: false,
    activeTab: "draft",
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBMITTED_WARRANTY_ACTION_TYPE.FETCH_SUBMITTED_WARRANTY_LIST: {
            return { ...state, isLoading: true, submittedList: [] };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.FETCH_SUBMITTED_WARRANTY_LIST_SUCCESS: {
            return { ...state, isLoading: false, submittedList: action.value };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.UPDATE_ACTIVE_TAB: {
            return { ...state, isLoading: false, activeTab: action.tab };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.RESET_SUBMITTED_WARRANTY_LIST: {
            return { ...state, isLoading: false, submittedList: [] };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.FETCH_SUBMITTED_WARRANTY_LIST_FAILURE: {
            return { ...state, isLoading: true, submittedList: [] };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.FETCH_STATE_PROVINCE_LIST: {
            return {
                ...state,
                isLoading: true,
                stateOrProvinceList: {
                    "": [{ label: "Select State", value: "" }],
                    USA: [{ label: "Select State", value: "" }],
                    CAN: [{ label: "Select Province", value: "" }],
                },
            };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.FETCH_STATE_PROVINCE_LIST_SUCCESS: {
            return { ...state, isLoading: false, stateOrProvinceList: action.value };
        }
        case SUBMITTED_WARRANTY_ACTION_TYPE.FETCH_STATE_PROVINCE_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                stateOrProvinceList: {
                    "": [{ label: "Select State", value: "" }],
                    USA: [{ label: "Select State", value: "" }],
                    CAN: [{ label: "Select Province", value: "" }],
                },
            };
        }
        default:
            return state;
    }
};

export default reducer;
